import React from 'react';
import {connect} from 'react-redux';
import {BaseStackSummary} from 'components/organisms/stack-summary/components/sports/lol';
import $ from 'jquery';

class StackSummaryComponent extends BaseStackSummary {
    componentDidMount() {
        $('body').scrollTop(0);
    }

    render() {
        const {rawLineups} = this.props;
        const groups = this.prepareGroups();
        const lineupsQuantity = rawLineups.getQuantity();
        const teamsQuantity = this.countTeams(groups);

        const content = Object.keys(groups).map((groupNumber) => {
            return this.getTeamsStackView(groupNumber, groups[groupNumber]);
        });

        isEmpty(content) && content.push(this.getNotFoundView());

        return (
            <div className="tab-content stack-summary-content">
                <div className="lineups-info-holder">
                    <ul className="lineups-info">
                        <li>
                            <strong>{teamsQuantity}</strong> Teams Used
                        </li>
                        <li>
                            <strong>{lineupsQuantity}</strong> Lineups
                        </li>
                    </ul>
                </div>
                <div className="players-used-table table-holder">{content}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking, lineupsData, lineupTeamsStacks} = state;

    return {
        rawLineups: lineupsData.rawLineups,
        stacking: randomTeamStacking,
        lineupTeamsStacks,
    };
}

const StackSummary = connect(mapStatesToProps)(StackSummaryComponent);

export {StackSummary};
